<template>
  <a href="#" ref="busstop" v-if="isEmptyAd" class="dealer-car ad_car_search_block">
    <div class="iframe_code iframe_ad tttt"></div>
  </a>

  <a href="#" ref="busstop" v-else-if="getIframe" :data-id="adData && adData.id" class="dealer-car ad_car_search_block">
    <div v-if="showIframeBlock" class="iframe_code iframe_ad" v-html="getIframe"></div>
  </a>

  <div ref="busstop" @click="sendStatistic" v-else-if="ad &&!ad.link" :data-id="ad && ad.id"
       class="dealer-car ad_car_search_block">
    <img style="width: 100%;" :src="getImage"/>
  </div>

  <a ref="busstop" @click="sendStatistic" v-else :href="ad && ad.link || '#'" :data-id="ad && ad.id" target="_blank"
     class="dealer-car ad_car_search_block">
    <img style="width: 100%;" :src="getImage"/>
  </a>
</template>


<script>
import getBaseUrl from "@/helpers/getBaseUrl";

import ad from "@/mixins/ad"

import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  props: {
    ad: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data: () => ({
    showIframeBlock: false,
    isLoadIframe: false,
    adData: null
  }),
  mixins: [ad],
  methods: {
    ...mapMutations('dealers', {
      setCurBanner: 'setCurBanner',
      setResCars: 'setResCars'
    }),
    ...mapActions({
      adStatistic: 'ad/SEND_STATISTIC',
      sendViewsAd: 'ad/SEND_VIEWS_STATISTIC'
    }),
    sendStatistic() {
      this.adStatistic({id: this.ad.id});
    },
    setStyle() {
      if (this.$device.desktop()) {
        let elements = document.querySelectorAll('.iframe_code > iframe');
        if (elements.length) {
          elements.forEach(elem => {
            let koef = elem.height / elem.width;
            const carCard = elem.style.height = document.querySelector('.dealer-car.glider-slide:not(.ad_car_search_block)')
            if (carCard && elem.clientWidth * koef > carCard.clientHeight && koef > 1) {
              elem.style.height = carCard.clientHeight + 'px';
              elem.style.width = (carCard.clientHeight / koef) + 'px';
              elem.parentElement.style.display = 'flex';
              elem.parentElement.style.justifyContent = 'center';
            } else {
              elem.style.height = (elem.clientWidth * koef) + 'px';
            }
          })
        }
      } else if (this.$device.mobile() || this.$device.tablet()) {
        let elements = document.querySelectorAll('.glider .ad-car-block.glider-slide .iframe_code > iframe');
        if (this.$device.tablet() && (!elements || !elements.length)) {
          elements = document.querySelectorAll('.results-cards-wrap .ad-car-block .iframe_code > iframe');
        }
        if (elements && elements.length) {
          elements.forEach(elem => {
            let koef = elem.height / elem.width;
            elem.style.height = (elem.clientWidth * koef) + 'px';
          })
        }
      }
    },
    showAdAndSendStatistic() {
      if(this.showMenu && this.$device.mobile()){
        return false;
      }
      this.setStyle();
      setTimeout(() => {
        this.setMinHeight();
      }, 100)
      if (this.$refs.busstop) {
        this.$nextTick(() => {
          let adPos = this.$refs.busstop.getBoundingClientRect().top;

          const offset = document.querySelector('.cars-sliders-wrap.preloader-slider') ? document.querySelector('.cars-sliders-wrap.preloader-slider').clientHeight : 0
          if (adPos - window.innerHeight - offset < 0 && !this.showIframeBlock) {

            if (this.isEmptyAd) {
              if (this.curBanner >= this.adList.length) {
                this.setCurBanner(0);
              }

              this.adData = this.adList[this.curBanner > (this.adList.length - 1) ? 0 : this.curBanner]
              //this.adData = this.adList[this.curBanner > (this.adList.length - 1) ? 0 : this.curBanner];
              //this.ad.empty = false;

              this.setCurBanner(this.curBanner + 1);
              this.isLoadIframe = true;
            }
            this.loadScript();

            let data = {id: this.ad.id}

            this.showIframeBlock = true;
            if (this.ad && this.ad.isSlider) {
              data.isSlider = 1;
            }

            if (['OldCars', 'Car'].includes(this.$route.name)) {
              data.used = 1;
            }
            //used
            this.sendViewsAd(data);
          }
        })
      }
    },
    setMinHeight() {
      const resultA = document.querySelector(".results-cards-wrap > a");
      const adCarBlock = document.querySelector(".ad_car_search_block");

      const carHeight = resultA ? resultA.clientHeight : null;
      const adHeight = adCarBlock ? adCarBlock.clientHeight : null;

      if (adHeight > 0 && carHeight > adHeight) {
        document.querySelector(".ad_car_search_block").style.height = carHeight + 'px';
      }
    }
  },
  computed: {
    ...mapGetters(['showMenu']),
    ...mapState({
      isApp: (state) => state.isApp,
      scrollTop: (state) => state.scrollTop,
      screen: state => state.screen,
      adList: state => state.ad.adList,
      curBanner: (state) => state.dealers.curBanner
    }),
    isMobile() {
      return this.$device.mobile();
    },

    getImage() {
      if (this.adData && (!this.adData.img_mobile || !this.adData.img_desktop)) {
        return false;
      }
      return getBaseUrl() + '/img/rec/' + (this.$device.mobile() ? this.adData.img_mobile : this.adData.img_desktop);
    },
    isEmptyAd() {
      if (this.isLoadIframe) {
        return false;
      }
      return this.ad && this.ad.empty;
    }
  },
  mounted() {
    setTimeout(() => {
      this.showAdAndSendStatistic();
    }, 100);
    this.showAdAndSendStatistic();
  },
  watch: {
    ad: {
      handler() {
        if (!this.isApp) {
          this.adData = null;
          this.isLoadIframe = false;
        }
        if (this.isEmptyAd) {
          if (!this.isApp) {
            this.showIframeBlock = false;
          }
        }
      }
    },
    'screen.width': {
      handler() {
        this.setStyle();
      }
    },
    scrollTop() {
      this.showAdAndSendStatistic();
    },
    '$store.state.dealers.page': {
      handler() {
        this.showAdAndSendStatistic();
      }
    },
    '$store.state.moduleOldCars.cars.items': {
      handler() {
        this.showAdAndSendStatistic();
      }
    }
  }
}
</script>
